import { colors } from "@covertree/theme";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const LegalTypography = styled(Typography)({
  color: colors.grey3,
  fontStyle: "italic",
});
